// fastclick eliminates click delay in certain browsers
var fastclick = require('fastclick');
fastclick(document.body);

// svg polyfill for better xlink support
var svg4everybody = require('svg4everybody');
svg4everybody();

// global jquery
global.jQuery = require('jquery');

// placeholder attribute polyfill
require('jquery-placeholder');
jQuery('input, textarea').placeholder();


// Image/Video popup
require('magnific-popup');

// Slick slider
require('slick-carousel-browserify');

// Scroll library
require('scrollmagic');

// automatically require all modules
require('./modules/_accordion.js');require('./modules/_df.js');require('./modules/_dropdown.js');require('./modules/_faq.js');require('./modules/_header.js');require('./modules/_home.js');require('./modules/_modal.js');require('./modules/_results.js');require('./modules/_status.js');require('./modules/_subnav.js');
;
